import { createRoot } from "react-dom/client";
import styles from "./MedalShare.module.less";
import DSBridge from "dsbridge";
export const showMedalShare = (shareImgUrl, showImg = true) => {
  const modalId = "medal-share-container";

  const existingModal = document.getElementById(modalId);
  if (existingModal) {
    try {
      document.body.removeChild(existingModal);
    } catch (error) {
      console.warn("Failed to remove existing modal:", error);
    }
  }

  const modalDiv = document.createElement("div");
  modalDiv.id = modalId;
  document.body.appendChild(modalDiv);
  const root = createRoot(modalDiv);

  const destroyModal = () => {
    try {
      root.unmount();
    } catch (error) {
      console.warn("Failed to unmount root:", error);
    }

    try {
      if (document.body.contains(modalDiv)) {
        document.body.removeChild(modalDiv);
      }
    } catch (error) {
      console.warn("Failed to remove modal div:", error);
    }
  };

  const Modal = () => {
    const handleMaskClick = (e) => {
      if (e.target === e.currentTarget) {
        destroyModal();
      }
    };

    const handleShareType = (type) => {
      destroyModal();
      switch (type) {
        case 0: {
          DSBridge.call(
            "share.shareInfo",
            {
              type: "image",
              scene: 0,
              title: "口袋领航外教",
              image: shareImgUrl,
            },
            (back) => {
              console.log(back);
            },
          );
          break;
        }
        case 1: {
          DSBridge.call(
            "share.shareInfo",
            {
              type: "image",
              scene: 1,
              title: "口袋领航外教",
              image: shareImgUrl,
            },
            (back) => {
              console.log(back);
            },
          );
          break;
        }
        case 2: {
          DSBridge.call(
            "share.saveImage",
            {
              url: shareImgUrl,
            },
            (back) => {
              console.log(back);
            },
          );
          break;
        }
        default:
          break;
      }
    };

    return (
      <div className={styles.modalOverlay} onClick={handleMaskClick}>
        {showImg && <img className={styles["share-img"]} src={shareImgUrl} />}
        <div className={styles["footer"]}>
          <div className={styles["button-list"]}>
            <div
              className={styles["button-list-item"]}
              onClick={() => handleShareType(0)}
            >
              <img
                className={styles["icon"]}
                src={require("@/images/report/wx.png")}
              />
              <div className={styles["text"]}>微信</div>
            </div>
            <div
              className={styles["button-list-item"]}
              onClick={() => handleShareType(1)}
            >
              <img
                className={styles["icon"]}
                src={require("@/images/report/friend.png")}
              />
              <div className={styles["text"]}>朋友圈</div>
            </div>
            <div
              className={styles["button-list-item"]}
              onClick={() => handleShareType(2)}
            >
              <img
                className={styles["icon"]}
                src={require("@/images/report/photo.png")}
              />
              <div className={styles["text"]}>保存相册</div>
            </div>
          </div>
          <div className={styles["cancel-button"]} onClick={destroyModal}>
            取消
          </div>
        </div>
      </div>
    );
  };

  root.render(<Modal />);
  return destroyModal;
};
